import {CallEntity} from "./call-entity";
import {WebRtcSignalingContent} from "../../web-rtc-signaling";

export interface CallSignalingMessage {

    entity: CallEntity;

    call_id: string;

    session_id: string;

    installation_id: string;

    kind: SignalingMessageKind;

    content: WebRtcSignalingContent;

    peer_id: string;

}

export enum SignalingMessageKind {
    Unknown = "unknown",
    Answer = "answer",
    Offer = "offer",
    Ice = "ice"
}
